import {
  GraphDataEdge,
  GraphDataNode,
  QualifiedFeatureFragment,
} from "fe-common/graphql";

export type DiseaseReasoning = {
  diseaseName: string;
  diseaseId: string;
};
export type SelectedSuggestionForReasoning = {
  qualifiedFeature: QualifiedFeatureFragment;
  isBackgroundSuggestion: boolean;
};

export type GraphSelectionEdge = {
  path: GraphDataEdge;
  source: GraphDataNode;
  target: GraphDataNode;
};

export type GraphSelection = {
  selection: boolean;
  edges: GraphSelectionEdge[];
};

export interface DemoPaneStateFields {
  selectedSuggestion: SelectedSuggestionForReasoning;
  updateSelectedSuggestion: (
    selectedSuggestion: SelectedSuggestionForReasoning,
  ) => void;
  selectedDiseaseReasoning: DiseaseReasoning;
  updateSelectedDiseaseReasoning: (
    selectedDiseaseReasoning: DiseaseReasoning,
  ) => void;
  showTriageReasoning: boolean;
  setShowTriageReasoning: (showTriageReasoning: boolean) => void;
  graphSelection: GraphSelection;
  setGraphSelection: (GraphSelection) => void;
}
/***
 * This state manager handles all the state related to the demo pane,
 * the demo pane is activated via 'demo-pane' feature flag.
 * Once activated, if a question has reasoning for it, there will be a (?) icon
 * next to question, click on the icon will show a popup explaining the reasoning behind the questions
 * (which diseases were considered? and what references did we use?).
 *
 *
 *
 * We can click on a disease for it's own references.
 * Also there is an option to select a disease from the results page and watch it's reasoning
 * or watch the reasoning of the triage.
 * There is also an option to view a graph for the reasoning, while selecting edges from the graph
 * the list of references may change, so it is also stored in this state.
 */

type SetState = (state: Partial<DemoPaneStateFields>) => void;
type GetState = () => Partial<DemoPaneStateFields>;

export const demoPaneStateManager: (
  set: SetState,
  get: GetState,
) => DemoPaneStateFields = (set, get) => ({
  selectedSuggestion: null,
  updateSelectedSuggestion: (
    selectedSuggestion: SelectedSuggestionForReasoning,
  ) => set({ selectedSuggestion }),
  // Sometimes we want to be able to mark the selected suggestion as a disease so that
  // the demo pane will be loaded in the disease view
  selectedDiseaseReasoning: null,
  updateSelectedDiseaseReasoning: (
    selectedDiseaseReasoning: DiseaseReasoning,
  ) => set({ selectedDiseaseReasoning }),
  showTriageReasoning: false,
  setShowTriageReasoning: (showTriageReasoning: boolean) =>
    set({ showTriageReasoning }),
  graphSelection: null,
  setGraphSelection: (graphSelection: GraphSelection) =>
    set({ graphSelection }),
});
